"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ceregnano": {
    "850b426a": [{
      "hkey": "d7f18231",
      "slug": "lama-polesine-pezzoli",
      "name": "Lama Polesine-Pezzoli",
      "primary": true,
      "skipSearch": false
    }],
    "lama-polesine": [{
      "hkey": "d7f18231",
      "slug": "lama-polesine-pezzoli",
      "name": "Lama Polesine-Pezzoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ceregnano"
    }],
    "3600c553": [{
      "hkey": "d7f18231",
      "slug": "lama-polesine-pezzoli",
      "name": "Lama Polesine-Pezzoli",
      "primary": true,
      "skipSearch": false
    }],
    "pezzoli": [{
      "hkey": "d7f18231",
      "slug": "lama-polesine-pezzoli",
      "name": "Lama Polesine-Pezzoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;